// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"8ccbf5a3","297":"57eb10c1","643":"d01aeb9c"}[chunkId] + ".chunk.js";
};